import React from 'react';
import {Accordion, AccordionDetails, AccordionSummary, Stack, Typography} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {CLGLimitesPorSectorComercial} from '../../sistema/sistemas/clg/hooks/useLimiteCLG'; // Importa el tipo del hook
import {
    OperacionCLGLimitesAprobadosPaisFields,
    OperacionCLGSectorComercialFields
} from '../../sistema/sistemas/clg/types/fields';
import CardLimite from '../CardLimite';
import CLGDetalleTabla from "../../sistema/sistemas/clg/components/CLGDetalleTabla";
import {SistemaTipo} from "../../../types/enum/enum"; // Reutilizaremos CardLimite para mostrar datos del sector

interface LimitesCLGSectorComercialProps {
    sectorProcesado: CLGLimitesPorSectorComercial;
}

function LimitesCLGSectorComercial({ sectorProcesado }: LimitesCLGSectorComercialProps) {
    const { sector, aforos } = sectorProcesado;

    return (
        <Accordion defaultExpanded>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                id={`sector-header-${sector[OperacionCLGSectorComercialFields.CodSectorComercial]}`}
            >
                <Typography variant="h6">
                    {sector[OperacionCLGSectorComercialFields.NombreSectorComercial]}
                </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{px:0, pb:0 }}>
                <Stack gap={2}>
                    <CardLimite
                        fechaAprobacion={sector[OperacionCLGSectorComercialFields.FechaAprobacion]}
                        fechaVencimiento={sector[OperacionCLGSectorComercialFields.FechaVencimiento]}
                        idMensaje={sector[OperacionCLGLimitesAprobadosPaisFields.IdMensaje]}
                        codSistema={SistemaTipo.CLG}
                    />
                    <CLGDetalleTabla data={aforos} />
                </Stack>
            </AccordionDetails>
        </Accordion>
    );
}

export default LimitesCLGSectorComercial;
